import BreadCrumb from "common/breadcrumb";
import React from "react";
import DefaultSquareSoft from "./default-square-soft";
import OutlineIconSizesDisabled from "./outline-icon-sizes-disabled";

const FormSwitches = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Switch" pageTitle="Forms" />

                <div className="grid grid-cols-1 gap-x-5 xl:grid-cols-3">
                    <DefaultSquareSoft />
                    <OutlineIconSizesDisabled />
                </div>
            </div>
        </React.Fragment>
    );
}

export default FormSwitches;